/**
 * Utility functions for generating share URLs
 */

/**
 * Get the current domain from browser window
 * Works in any environment (local, staging, production)
 */
export const getCurrentDomain = (): string => {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  // Fallback for SSR or non-browser environments
  return 'https://naatcity.com';
};

/**
 * Generate a share URL for a naat
 * @param naatId - The ID of the naat
 * @returns Full URL to the naat detail page
 */
export const generateNaatShareUrl = (naatId: number | string): string => {
  return `${getCurrentDomain()}/naat/${naatId}`;
};

/**
 * Generate a share URL for a naat khawan
 * @param naatKhawanId - The ID of the naat khawan
 * @returns Full URL to the naat khawan page
 */
export const generateNaatKhawanShareUrl = (naatKhawanId: number | string): string => {
  return `${getCurrentDomain()}/naatkhawan/${naatKhawanId}`;
};

/**
 * Get the current page URL
 * @returns Current full URL
 */
export const getCurrentPageUrl = (): string => {
  if (typeof window !== 'undefined') {
    return window.location.href;
  }
  return getCurrentDomain();
};

/**
 * Generate Open Graph image URL
 * @param imagePath - Relative or absolute image path
 * @returns Full URL to the image
 */
export const generateOgImageUrl = (imagePath?: string): string => {
  if (!imagePath) {
    return `${getCurrentDomain()}/og-image.jpg`;
  }
  
  // If already absolute URL, return as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // Add domain to relative path
  const cleanPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
  return `${getCurrentDomain()}${cleanPath}`;
};
